import {B2BBarcodeContextState} from '../types/B2BBarcode';
import {DefaultContext} from '../../utils/types';
import React from 'react';

export const initialState: B2BBarcodeContextState = {
  listOfBarcodes: [],
  barcodesScannedCount: 0,
};

const defaultVal: DefaultContext<B2BBarcodeContextState> = {
  state: initialState,
  dispatch: null,
};

export const B2BBarcodesContext = React.createContext(defaultVal);
